<script lang="ts" setup>
import {
    GlobalThemeOverrides,
    NConfigProvider,
    NDialogProvider,
    NLoadingBarProvider,
    NMessageProvider,
    NModalProvider,
} from "naive-ui";
import { useClarity } from "./hooks/useClarity";
import { initializeFeatureFlags } from "./hooks/useFeatureFlags";

// Initialize Clarity analytics
useClarity();

// Initialize feature flags
initializeFeatureFlags();

const themeOverrides: GlobalThemeOverrides = {
    common: {
        primaryColor: "#1D1C3DFF",
        primaryColorHover: "#5025C1FF",
        primaryColorPressed: "#9062E7FF",
        primaryColorSuppl: "#5025C1FF",
        infoColor: "#54B3EDFF",
        infoColorHover: "#76C2F1FF",
        infoColorPressed: "#98D1F4FF",
        infoColorSuppl: "#54B3EDFF",
        textColorBase: "#14132a",
        textColor1: "#444452FF",
        textColor2: "#2c2c2c",
        textColor3: "#B4B4C2FF",
        textColorDisabled: "#E8E8EEFF",
        successColor: "#4DA462FF",
        successColorHover: "#71B682FF",
        successColorSuppl: "#4DA462FF",
        successColorPressed: "#94C8A1FF",
        borderRadius: "3px",
        borderRadiusSmall: "8px",
        errorColor: "#D74242FF",
        warningColor: "#FF9E1AFF",
        warningColorSuppl: "#FF9E1AFF",
        warningColorHover: "#FFB147FF",
        warningColorPressed: "#FFC575FF",
        errorColorHover: "#DF6868FF",
        errorColorSuppl: "#D74242FF",
        errorColorPressed: "#E78D8DFF",
    },
    Button: {
        iconSizeSmall: "16px",
    },
    Input: {
        borderRadius: "2em",
        // Ensure iOS doesn’t auto-zoom: needs >= 16px
        fontSizeMedium: "16px",
    },
    Select: {
        peers: {
            InternalSelection: {
                borderRadius: "2em",
                // Prevent iOS zoom on select
                fontSizeMedium: "16px",
            },
            InternalSelectMenu: {
                optionFontSizeMedium: "16px",
                borderRadius: "2em",
            },
        },
    },
    Checkbox: {
        colorChecked: "#5025C1FF",
    },
    DatePicker: {
        panelBorderRadius: "2em",
        peers: {
            Input: {
                borderRadius: "2em",
                borderHover: "#5025C1FF",
                // Prevent iOS zoom on datepicker input
                fontSizeMedium: "16px",
            },
        },
    },
    InternalSelectMenu: {
        optionFontSizeMedium: "16px",
    },
    InternalSelection: {
        fontSizeMedium: "16px",
    },
};
</script>

<template>
    <n-config-provider :theme-overrides="themeOverrides" class="h-full">
        <n-modal-provider>
            <n-loading-bar-provider>
                <n-dialog-provider>
                    <n-message-provider>
                        <router-view />
                    </n-message-provider>
                </n-dialog-provider>
            </n-loading-bar-provider>
        </n-modal-provider>
    </n-config-provider>
</template>

<style>
/* Mobile fallback to ensure native inputs don’t trigger iOS auto-zoom */
@media (max-width: 480px) {
  input,
  textarea,
  select,
  button {
    font-size: 16px;
  }
}
</style>
